import { createJSONStorage } from "zustand/middleware";

function createSafeStorage() {
  return createJSONStorage(() => ({
    getItem: (name) => {
      try {
        return localStorage.getItem(name);
      } catch {
        return null;
      }
    },
    setItem: (name, value) => {
      try {
        localStorage.setItem(name, value);
      } catch {
        // iOS private browsing / storage restrictions
      }
    },
    removeItem: (name) => {
      try {
        localStorage.removeItem(name);
      } catch {
        // ignore
      }
    },
  }));
}

export const safeLocalStorage = createSafeStorage();
